import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Grid, Group, Icon, Text } from '@zorro/web/design-system';
import { useTextOverflow } from '@zorro/web/ui-utils';
import { ElementType } from 'react';

import { EnrollmentReviewCardCurrency } from '../EnrollmentReviewCard';

type Props = {
  premium: number;
  icon: ElementType;
  name: string;
  isHighlighted?: boolean;
};

export const EnrollmentAllowanceCardItem = ({
  icon,
  name,
  premium,
  isHighlighted,
}: Props) => {
  const { textRef, isTextOverflowing } = useTextOverflow(name);
  const highlightedColor = isHighlighted
    ? 'var(--brand-purple-500)'
    : undefined;

  return (
    <>
      <Grid.Col span={7} pr="sm">
        <Tooltip label={name} disabled={!isTextOverflowing}>
          <Group gap="xs" wrap="nowrap" style={{ overflow: 'hidden' }}>
            <Icon icon={icon} size={16} style={{ flexShrink: 0 }} />
            <Text ref={textRef} c={highlightedColor} size="sm" truncate>
              {name}
            </Text>
          </Group>
        </Tooltip>
      </Grid.Col>
      <Grid.Col span="auto">
        {Number.isFinite(premium) && (
          <EnrollmentReviewCardCurrency
            c={highlightedColor}
            style={{ textWrap: 'nowrap' }}
          >
            {premium}
          </EnrollmentReviewCardCurrency>
        )}
      </Grid.Col>
    </>
  );
};
